// extracted by css-extract-rspack-plugin
export default {"selectMaintainerTags":"xm6p5yiZ3Ys6jZY_","menuSection":"xVbfyErzZm0Qg2Rf"};